import { Button, Tooltip } from '@chakra-ui/react';
import React from 'react';

import { InvoiceReportGQLType } from 'types/dashboard-core-gqlTypes.generated.d';

import { Icon } from 'packages/common-frontend/components/icons';
import { useDownloadReportUrl } from 'packages/reporting/hooks/useDownloadReportUrl';

export const DisbursementNoticeDownloadButton = ({
  report,
}: {
  report: InvoiceReportGQLType;
}) => {
  const { getReportDownloadUrl } = useDownloadReportUrl(report);

  return (
    <Tooltip label="Download Funding Disbursement">
      <Button variant="v2-ghost" onClick={getReportDownloadUrl}>
        <Icon icon="arrow-down-to-bracket" />
      </Button>
    </Tooltip>
  );
};
